export default {
  title: 'Déduplication des partenaires',
  subtitle: 'Réviser et fusionner les partenaires d\'affaires en double détectés par Meilisearch.',
  scan_now: 'Lancer un scan',
  scanning: 'Scan en cours...',
  scan_started: 'Scan en file d\'attente. Les nouveaux doublons apparaîtront à la fin du traitement.',
  auto_merge: 'Fusion auto ({count} évidents)',
  auto_merge_done: 'Fusion auto terminée. Fusionnés : {merged}, ignorés : {skipped}.',
  auto_merge_confirm: {
    title: 'Fusion automatique des doublons évidents',
    body: 'Ceci fusionnera {count} paires ayant une correspondance parfaite (score ≥ 0,98) ET une adresse identique. Le gardien est choisi automatiquement : plus de références → plus ancien → champs les plus remplis. Continuer ?',
    confirm: 'Tout fusionner',
  },
  no_candidates: 'Aucun doublon en attente de révision.',
  threshold: 'Seuil de correspondance',
  refresh: 'Rafraîchir',
  search_placeholder: 'Recherche par nom, nom légal ou nom de facturation…',
  score: 'Score',
  diff_legend: 'Vert = identique au gardien, orange = différent, gris = uniquement un côté.',
  cluster: {
    header: '{count} doublon(s) détecté(s) pour ce partenaire',
    score_range: 'Plage de score : {min} – {max}',
    keeper_label: 'Gardien (suggéré)',
    keeper_badge: 'GARDIEN',
    select_all: 'Tout sélectionner ({count})',
    merge_selected: 'Fusionner la sélection ({count})',
    review_pair: 'Réviser',
    merge_help: 'La fusion en lot règle tous les conflits en faveur du gardien. Pour choisir champ par champ (adresse, paramètres, checklists), utilisez « Réviser » sur une ligne spécifique.',
    confirm_body: '{count} partenaire(s) seront fusionné(s) dans le gardien. Chaque fusion transfère les FK et supprime (soft) le perdant. Continuer ?',
    confirm_body_with_winners: '{count} partenaire(s) seront fusionné(s) dans le gardien, avec {overrides} champ(s) écrasé(s) par vos choix. Continuer ?',
    pick_winner_tooltip: 'Utiliser cette valeur sur le gardien après fusion',
    keeper_overridden: 'Deviendra',
    scope_shared: 'Partagé · toutes compagnies',
    scope_company: 'Seulement · {name}',
    will_become_shared: '→ deviendra Partagé',
    scope_summary_title: 'Portée compagnie',
    scope_summary_keeper_shared: 'Le gardien est partagé entre toutes les compagnies. Le résultat reste partagé.',
    scope_summary_keeper_company: 'Le gardien appartient seulement à {name}. Le résultat restera réservé à {name} sauf si des perdants partagés ou d\'une autre compagnie sont sélectionnés.',
    scope_summary_will_demote: 'Le gardien est actuellement réservé à {current}, mais des perdants sélectionnés sont partagés ou d\'une autre compagnie → le résultat deviendra partagé entre toutes les compagnies.',
    supplier_hint_title: 'Toutes les transactions sont des factures d\'achat',
    supplier_hint_body: 'Les {count} transaction(s) liées à ce groupe sont des « bills ». Le gardien ressemble à un fournisseur plutôt qu\'à un client.',
    convert_to_supplier: 'Convertir le gardien en Fournisseur',
    type_changed_to_supplier: 'Type du gardien changé en Fournisseur.',
    merge_done: 'Cluster fusionné. Succès : {merged}, échecs : {failed}.',
  },
  oldest_badge: 'plus ancien',
  counts: {
    transactions: 'Tx',
    service_calls: 'Appels',
    lease_contracts: 'Baux',
    part_options: 'Fourn.',
    transaction_items: 'Vendu',
  },
  fields: {
    name: 'Nom',
    legal_name: 'Légal',
    invoicing_name: 'Nom de facturation',
    email: 'Courriel',
    phone: 'Téléphone',
    billing_address: 'Adresse de facturation',
    shipping_address: 'Adresse de livraison',
    created_at: 'Créé le',
    updated_at: 'Dernière mise à jour',
    last_transaction_at: 'Dern. tx',
  },
  actions: {
    keep_left: 'Garder gauche',
    keep_right: 'Garder droite',
    keep_suggested: 'Garder (suggéré)',
    not_a_duplicate: 'Pas un doublon',
  },
  confirm: {
    title: 'Confirmer la fusion',
    body: 'Le partenaire perdant sera archivé (suppression douce) et toutes ses références (transactions, baux, adresses, contacts, étiquettes) seront transférées au gardien.',
    keeper: 'Gardé',
    loser: 'Fusionné',
    confirm: 'Fusionner',
    cancel: 'Annuler',
    loading: 'Recherche de conflits...',
    no_conflicts: 'Aucun conflit. Les données du perdant seront transférées ou supprimées silencieusement si identiques.',
    conflicts_title: '{count} champ(s) en conflit — choisissez la valeur à conserver',
    use_keeper: 'Garder la valeur du gardien',
    use_loser: 'Utiliser la valeur du perdant',
    drops_note: '{count} ligne(s) identique(s) seront supprimées silencieusement :',
  },
  errors: {
    merge_failed: 'Échec de la fusion : {message}',
    scan_failed: 'Impossible de démarrer le scan : {message}',
    load_failed: 'Impossible de charger les doublons : {message}',
  },
}
